import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Copia o texto do proprio elemento (ex.: campos selecionaveis de documentos)
  copy(event) {
    const el = event.currentTarget
    this.write(el.textContent.trim(), el)
  }

  // Copia um texto informado via data-clipboard-text-param (ex.: link de assinatura)
  copyText(event) {
    event.preventDefault()
    this.write(event.params.text, event.currentTarget)
  }

  write(text, el) {
    if (!text) return

    navigator.clipboard.writeText(text).then(() => {
      el.classList.add("!bg-primary-100", "!border-primary-400", "!text-primary-900")
      setTimeout(() => el.classList.remove("!bg-primary-100", "!border-primary-400", "!text-primary-900"), 700)
    })
  }
}
